import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicChangerAthlete = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Vos inscriptions', link: '/topics/inscription/modification'},
    { label: topic.title, link: topic.link},
  ];

  // <a target='_blank' className="link" href="https://wodzone.fr">https://wodzone.fr</a>


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Un athlète ne peut plus participer avec vous ? Une erreur lors de votre inscription ?
              Si la date limite de modification n'est pas dépassée, vous pourrez modifier les informations saisies lors de votre inscription.
              Pour en savoir plus sur
              <a target='_blank' className="link" href='/topics/inscription/35'>comment modifier ses informations d'inscription.</a>
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Toutes vos<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/events`}>informations d'inscription</a>
                sont disponibles depuis votre compte. Il vous suffit de cliquer sur la compétition qui vous intéresse pour les consulter.
              </p>
              <p className="help-text mt-24">
                On va appeler capitaine, l'athlète qui a validé l'inscription pour lui et pour son équipe.
              </p>
              <p className="help-text mt-24">
                Le capitaine peut modifier tous les membres de l'équipe, y compris lui-même. Les autres membres de l'équipe ne peuvent changer que leur propre place. <br/>
                Pour ce faire, cliquez sur le bouton <i className="fa-solid fa-people-arrows"></i> situé en haut à droite de la section <strong>Athlète :</strong>
              </p>
              <ul className="mt-0">
                <li className="pl-8 mb-8"><p className="help-text">Saisissez le nom du nouvel athlète si celui possède déjà un compte Wodzone.</p></li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Sinon cliquez sur <strong>Cet athlète n'est pas présent ?</strong> puis saississez toutes les informations personnelles de ce nouvel athlète.
                  </p>
                </li>
                <li className="pl-8 mb-8"><p className="help-text">Cliquer sur enregistrer.</p></li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Tous les athlètes concernés par cette opération recevront un e-mail confirmant la mise à jour.
                  </p>
                </li>
              </ul>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicChangerAthlete